module.exports = __webpack_public_path__ + "img/failing_test_path.2f88e0d8.png";